/* eslint-disable max-lines */
import moment from 'moment';
import datePicker from '../../../../common/components/date-picker/date-picker';
import debounce from 'lodash-es/debounce';
import pattern from '../../../../common/js/validators/pattern';
import date from '../../../../common/js/validators/date';
import ageGreaterThan from '../../../../common/js/validators/age-greater-than';
import ageLessThan from '../../../../common/js/validators/age-less-than';
import { required, minLength } from 'vuelidate/lib/validators';
import email from '../../../../common/js/validators/email';

import bankBranchSelector from '../../../../common/components/bank-branch-selector/bank-branch-selector.vue';
import { DISPLAY_DATE_FORMAT, BACKEND_DATE_FORMAT, NAME_REGEXP, MOBILE_PHONE_REGEXP, ZIP_CODE_REGEXP } from '../../../../common/js/constants/constants';
import { PROVIDER_PREFIXES } from '../../constants/oki-constants';
import VueSettlementSelector from '@ui-common/vue-settlement-selector';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueInput from '@ui-common/vue-input';
import VueErrorMessage from '@ui-common/vue-error-message';
import { VueCombobox, VueComboboxOption } from '@ui-common/vue-combobox';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueCaptcha from '@ui-common/vue-captcha';
const mapToKeyValue = (arr) =>
	arr.map((item) => {
		return {
			key: item.code,
			value: item.displayValue
		};
	});

const CLAIM_CODE_REGEXP = '[0-9]{8}';
export default {
	data() {
		return {
			model: {
				hasClaimCode: false,
				claimCode: null,
				fullName: null,
				birthNameIsDifferent: null,
				birthName: null,
				birthPlace: '',
				dateOfBirth: null,
				mothersMaidenName: null,
				mobilePhoneNumber: null,
				mobileProvider: null,
				email: null,
				notificationMethod: null,
				postalCode: null,
				settlement: null,
				address: null,
				handoverBranch: {
					code: null,
					county: null,
					district: null
				},
				adNoticeConsent: null
			},
			captchaText: null,
			address: {
				zipCode: null,
				settlement: null
			},
			bankBranchSelectorData: {},
			bankBranchFormSubmitted: false,
			showCaptchaError: false,
			hasClaimCodeChanged: false
		};
	},
	props: [
		'soki',
		'settlements',
		'mobileProviders',
		'birthPlaces',
		'counties',
		'districts',
		'captcha',
		'bankBranches',
		'captchaError',
		'personalData',
		'cardData'
	],
	validations() {
		return {
			model: {
				claimCode: this.model.hasClaimCode
					? {
							required,
							minLength: minLength(8),
							pattern: pattern(CLAIM_CODE_REGEXP)
					  }
					: {},
				fullName: {
					required,
					minLength: minLength(5),
					pattern: pattern(NAME_REGEXP)
				},
				birthName: this.model.birthNameIsDifferent
					? {
							required,
							minLength: minLength(5),
							pattern: pattern(NAME_REGEXP)
					  }
					: {},
				birthPlace: {
					required
				},
				dateOfBirth:
					this.cardData && this.cardData.ageMax !== null
						? {
								required,
								validDate: date(DISPLAY_DATE_FORMAT[this.$lang]),
								ageGreaterThan: ageGreaterThan(DISPLAY_DATE_FORMAT[this.$lang], this.cardData.ageMin),
								ageLessThan: ageLessThan(DISPLAY_DATE_FORMAT[this.$lang], this.cardData.ageMax)
						  }
						: {
								required,
								validDate: date(DISPLAY_DATE_FORMAT[this.$lang]),
								ageGreaterThan: ageGreaterThan(DISPLAY_DATE_FORMAT[this.$lang], this.cardData && this.cardData.ageMin)
						  },
				mothersMaidenName: {
					required,
					minLength: minLength(5),
					pattern: pattern(NAME_REGEXP)
				},
				mobilePhoneNumber: {
					required,
					pattern: pattern(MOBILE_PHONE_REGEXP)
				},
				mobileProvider: {
					required
				},
				email: {
					required,
					email
				},
				notificationMethod: !this.model.hasClaimCode
					? {
							required
					  }
					: {},
				postalCode: {
					required,
					pattern: pattern(ZIP_CODE_REGEXP)
				},
				settlement: {
					required
				},
				address: {
					required,
					minLength: minLength(5)
				},
				handoverBranch: !this.model.hasClaimCode
					? {
							code: {
								required
							}
					  }
					: {}
			},
			captchaText: this.captcha && this.captcha.htmlFragment ? { required } : {}
		};
	},
	components: {
		datePicker,
		bankBranchSelector,
		VueSettlementSelector,
		VueCheckbox,
		VueInput,
		VueErrorMessage,
		VueCombobox,
		VueComboboxOption,
		VueMobilephoneInput,
		VueSelect,
		VueSelectOption,
		VueRadioGroup,
		VueCaptcha
	},
	watch: {
		'model.hasClaimCode'(value) {
			if (!value) {
				this.$v.model.claimCode.$reset();
				this.$v.model.notificationMethod.$reset();
				this.model.claimCode = null;
			} else {
				this.$v.model.notificationMethod.$reset();
				this.model.notificationMethod = null;
				this.$v.model.handoverBranch.$reset();
				this.model.handoverBranch.code = null;
				this.model.handoverBranch.district = null;
				this.model.handoverBranch.county = null;
				this.bankBranchSelectorData = {
					code: null,
					district: null,
					county: null
				};
			}
		},
		identificationDocuments(value) {
			if (value && value.length && value[0].key) {
				this.model.identityDocument = value[0].key;
			}
		},
		address: {
			handler({ zipCode, settlement }) {
				if (zipCode || zipCode === '' || zipCode === 0) {
					this.model.postalCode = zipCode;
					this.model.settlement = settlement;
					this.$v.model.postalCode.$touch();
					this.$v.model.settlement.$touch();
				}
			},
			deep: true
		},
		bankBranchSelectorData: {
			handler({ address, county, district }) {
				if (address) {
					this.model.handoverBranch.code = address;
					this.model.handoverBranch.county = county;
					this.model.handoverBranch.district = district;
				}
			},
			deep: true
		},
		'model.birthNameIsDifferent'(value) {
			if (!value) {
				this.model.birthName = '';
				this.$v.model.birthName.$reset();
			}
		},
		'model.mobilePhoneNumber'(value) {
			if (value) {
				let prefix = value.substring(0, 2);
				this.model.mobileProvider = PROVIDER_PREFIXES[prefix];
			}
		},
		personalData(val) {
			if (val) {
				this.convertToFrontendModel(val);
			}
		},
		'model.captchaText'(value) {
			if (value) {
				this.captchaError = false;
			}
		},
		captchaError(value) {
			if (value === true) {
				this.captchaText = '';
			}
			this.showCaptchaError = !!value;
		}
	},
	computed: {
		dateMin() {
			return moment()
				.subtract((this.cardData && this.cardData.ageMax) || 100, 'years')
				.format(BACKEND_DATE_FORMAT);
		},
		dateMax() {
			return moment()
				.subtract((this.cardData && this.cardData.ageMin) || 0, 'years')
				.format(BACKEND_DATE_FORMAT);
		},
		covertedCounties() {
			return mapToKeyValue(this.counties);
		},
		covertedDistricts() {
			return mapToKeyValue(this.districts);
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		selectedCardText() {
			for (let identificationDocument of this.identificationDocuments) {
				if (this.model.identityDocument == identificationDocument.key) {
					return identificationDocument.value;
				}
			}
			return '';
		},
		eighteenYearsOld() {
			return moment().subtract((this.cardData && this.cardData.ageMin) || 0, 'y');
		}
	},
	methods: {
		onHasClaimCodeChanged() {
			this.hasClaimCodeChanged = true;
			this.$emit('on-has-claim-code-change', this.hasClaimCodeChanged);
		},
		scrollToDataManagement() {
			let dataManagementElement = document.getElementById('oki-data-management-information');
			this.$scrollTo(dataManagementElement, { duration: 500 });
		},
		setAndLookupCity(query) {
			this.lookupCity(query.trim());
		},
		lookupCity: debounce(function (query) {
			query = query.trim();
			if (query && query.length >= 2) {
				this.$emit('on-lookup-settlements', query);
			} else {
				this.$emit('on-reset-settlements', query);
			}
		}, 300),

		bankBranchSearch(data) {
			this.$emit('on-bank-branch-search', data);
		},
		convertToFrontendModel(val) {
			let model = Object.assign({}, this.model, val);
			if (val.postalCode) {
				this.address = {
					zipCode: val.postalCode,
					settlement: val.settlement
				};
			}
			if (val.handoverBranch && val.handoverBranch.code) {
				this.bankBranchSelectorData = {
					county: val.handoverBranch.county,
					district: val.handoverBranch.district,
					address: val.handoverBranch.code
				};
			}
			this.model = model;
		},
		getSettlements(zipCode) {
			this.$emit('on-zip-change', zipCode);
		},
		getMailingSettlements(zipCode) {
			this.$emit('on-mailing-zip-change', zipCode);
		},
		postPersonalForm() {
			this.bankBranchFormSubmitted = true;
			if (this.isValid()) {
				let model = this.convertToBackendModel();
				this.$emit('on-post-personal-form', { personalData: model, captchaText: this.captchaText });
			} else {
				this.$nextTick(() => {
					let elem = document.querySelector('.has-error');
					this.$scrollTo(elem, { duration: 500 });
				});
			}
		},
		isValid() {
			this.$v.$touch();
			return !this.$v.$invalid;
		},
		convertToBackendModel() {
			return Object.assign({}, this.model);
		}
	},
	created() {
		if (this.personalData) {
			this.convertToFrontendModel(this.personalData);
		}
	}
};
/* eslint-enable max-lines */
